import React, { useState,useEffect } from "react";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";
import axios from "axios";
import { Link, useNavigate } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import Swal from 'sweetalert2';
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { AddSubscription, CreatePaymentIntent } from "../apiconstants/constants";


const StripePayment = ({ locationState }) => {
  const navigate = useNavigate();
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
const token = localStorage.getItem("jwtToken");

 const { amount: initialAmount, type, plan ,planId} = locationState || {};
  console.log("type",type,plan)

  const [amount, setAmount] = useState(initialAmount);
  const userName = localStorage.getItem("firstName") || "No Name Provided";
  const userEmail = localStorage.getItem("email")  || "No Email Provided";

  const [startDate, setStartDate] = useState(() => new Date().toISOString());
  const [endDate, setEndDate] = useState(() => {
    const date = new Date();
    if (plan === "Monthly") {
      date.setMonth(date.getMonth() + 1);
    } else if (plan === "Annually") {
      date.setFullYear(date.getFullYear() + 1);
    }
    return date.toISOString();
  });
  
  const savedEndDate = new Date(localStorage.getItem("subscriptionEndDate")); // Assume you store this
const today = new Date();


useEffect(() => {
  if (savedEndDate > today) {
    Swal.fire({
      title: "Active Subscription",
      text: `You already have a subscription valid until ${savedEndDate.toDateString()}. Do you want to renew it now?`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Yes, Renew",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#00a7ac", 
      cancelButtonColor: "#f44336"   // Red
    }).then((result) => {
      if (result.isConfirmed) {
        // Extend dates
        const newStart = savedEndDate;
        const newEnd = new Date(newStart);
        if (plan === "Monthly") {
          newEnd.setMonth(newEnd.getMonth() + 1);
        } else if (plan === "Annually") {
          newEnd.setFullYear(newEnd.getFullYear() + 1);
        }
        setStartDate(newStart.toISOString());
        setEndDate(newEnd.toISOString());
      } else {
        navigate("/Employer/Subscriptionplans"); // 👈 Redirect on Cancel
      }
    });
  }
}, []);

let Guid="";

const guid = localStorage.getItem("guid");
const employerGuid = localStorage.getItem("employerGuid")
const roleID = localStorage.getItem("roleID")

if(roleID==3){
 Guid = employerGuid
}
else{
  Guid= guid
}

const handleSubmit = async (event) => {
  event.preventDefault();
  setLoading(true);

  if (!stripe || !elements) {
    setLoading(false);
    return;
  }

  const cardElement = elements.getElement(CardElement);

  try {
    const amountInCents = Math.round(parseFloat(amount) * 100);
    if (isNaN(amountInCents) || amountInCents <= 0) {
      setMessage("Please enter a valid amount.");
      setLoading(false);
      return;
    }

const payload ={
  "amount": amountInCents,
  "userGuid": Guid,
  "userName": userName,
  "userEmail": userEmail
}
    // 1. Create Payment Intent
    const { data } = await axios.post(CreatePaymentIntent.APIURL, payload,
      { headers: {
        Authorization: `Bearer ${token}`,
      }
    }
    );
    const { clientSecret, paymentIntentId } = data;
    // 2. Confirm Card Payment
    const paymentResult = await stripe.confirmCardPayment(clientSecret, {
      payment_method: { card: cardElement },
    });


    if (paymentResult.error) {
      setMessage("Payment could not be completed. Please check your card details and try again.");
      Swal.fire({
        icon: 'error',
        title: 'Payment Failed',
        text: "Payment could not be completed. Please check your card details and try again.",
      });
    } else {
      setMessage("Payment successful!");
      setAmount("");
      console.log("131",endDate)
  const payload={
  "userGuid": Guid,
  "fullName": userName,
  "email": userEmail,
  "stripeSubscriptionId": paymentIntentId,
  "planId": planId,
  "startDate": startDate,
  "endDate": endDate
}

console.log("142",payload)
      // 3. Save Payment Info to Backend
      try {
     const response =  await axios.post(AddSubscription.APIURL, payload,
      { headers: {
        Authorization: `Bearer ${token}`,
      } 
      }
     );
if(response.data.message.message=="ADDED SUCCESSFULLY"){
    localStorage.setItem('isSubscriptionActive', response.data.message.isTrialActive)  
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Payment Successful',
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          localStorage.setItem("showPostPaymentAlert", "true");
          navigate("/Employer/SubscriptionPlans");
        });
      }
      } catch (saveError) {
        console.error("Save payment error:", saveError);
        setMessage("Payment was successful, but we couldn't save your subscription. Please contact support.");
        Swal.fire({
          icon: 'warning',
          title: 'Subscription Issue',
          text: "Payment was successful, but we couldn't save your subscription. Please contact support.",
        });
      }
    }
  } catch (error) {
    console.error("Payment error:", error);
    let errorMsg = "Something went wrong. Please try again later.";

    if (error.response) {
      if (error.response.status === 404) {
        errorMsg = "Service unavailable. Please try again in a few minutes.";
      } else if (error.response.data?.error?.message?.includes("No such payment_intent")) {
        errorMsg = "Your session expired. Please refresh the page and try again.";
      } else if (error.response.data?.message?.toLowerCase().includes("amount")) {
        errorMsg = "Invalid payment amount. Please enter a valid amount.";
      }
    } else if (error.request) {
      errorMsg = "Network error. Please check your internet connection.";
    }

    setMessage(errorMsg);
    Swal.fire({
      icon: 'error',
      title: 'Payment Failed',
      text: errorMsg,
    });
  }

  setLoading(false);
};



  return (
    <div className="home-container">
     <ConsultantLayout>
      <div className="card shadow-sm p-3 mt-3" style={{ border: "none", backgroundColor: "#fff" }}>
        <div className="card-header" style={{ border: "none", backgroundColor: "#fff" }}>
        
                                  <Link to="/Employer/SubscriptionPlans">
                                      <h5 className="welcome-text" style={{ fontSize: '20px', color: '#00a7ac', textAlign: 'left' }}>
                                          <i className="fa fa-arrow-left" style={{ marginRight: '30px' }} aria-hidden="true"></i>Payment 
                                      </h5>
                                  </Link>
                              </div>
                              <hr />
  
        <div className="container">
          <div className="row mt-2">
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
            <div className="mt-3">
                <input
                  type="text"
                  placeholder="Email"
                  value={userEmail}
                  required
                  className="form-control"
                />
               </div>
              
               <form onSubmit={handleSubmit}>
  <div>
    <input
      type="text"
      placeholder="Enter amount (USD)"
      value={amount}
      disabled
      onChange={(e) => setAmount(e.target.value)}
      required
      className="form-control mt-3"
    />
  </div>

  <div className="mt-3">
    <CardElement />

  </div>

  <div className="btn-group mt-3">
    <button className="btn btn-primary" type="submit" disabled={!stripe || loading}>
      {loading ? "Processing..." : `Pay $${amount || "0"}`}
    </button>
  </div>
</form>

            </div>
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6">
            
            <div className="mt-3">
                <input
                  type="text"
                  placeholder="Name on card"
                  value={userName}
                  required
                  className="form-control"
                />
               </div>
             

            </div>
           
             
              
        </div>
      </div>
      </div>
    </ConsultantLayout>
  </div>
  
  );
};


export default StripePayment;
